module.exports = __webpack_public_path__ + "media/images/black_history_month/chef-image-448d3d47f0db3a5b3312a33efc2a6ef4.png";